import { log } from 'evlog/client';
import { LogOut as LogOutIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

import {
  Button,
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from '@virtual-care/shadcn';

import { logout } from '../firebase';

export default function Logout() {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleLogout = () => {
    log.info({ action: 'logout' });
    logout().then(() => {
      navigate('/signin');
    });
  };

  return (
    <div className="flex flex-1 items-center justify-center p-4 pt-6">
      <Card className="w-full max-w-md">
        <CardHeader className="text-center">
          <div className="mb-4 flex justify-center">
            <div className="flex h-16 w-16 items-center justify-center rounded-full bg-red-100">
              <LogOutIcon className="h-8 w-8 text-red-600" />
            </div>
          </div>
          <CardTitle className="text-2xl">{t('auth.logout.title')}</CardTitle>
          <p className="text-muted-foreground mt-2 text-sm">
            {t('auth.logout.confirm')}
          </p>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="flex flex-col space-y-2">
            <Button
              onClick={handleLogout}
              variant="destructive"
              className="w-full text-zinc-50"
            >
              <LogOutIcon className="mx-2 h-4 w-4 text-zinc-50" />
              {t('auth.logout.submit')}
            </Button>
            <Button
              onClick={() => navigate('/')}
              variant="outline"
              className="w-full"
            >
              {t('auth.logout.cancel')}
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
